const CustomResourceApplyHBHF = () =>
  import('@/views/main/report/customResourceApply/CustomResourceApplyHBHF.vue')

export default {
  path: '/main/report/customResourceApplyHBHF',
  name: 'customResourceApplyHBHF',
  component: CustomResourceApplyHBHF,
  children: []
}
